<template>
    <aside class="menu mt-5 ml-5"  :id="'col_filter'">
        <p class="menu-label ml-10">
            Category
        </p>
        <div class="enable-scroll max-80vh overflow-x-hidden">
          <ul class="menu-list" v-for="cat in filterCats" :key="cat.mid">
              <li>
                  <a @click.prevent="showSubmenu(cat)" :class="{ 'is-active' : active_el == cat.mid }">{{cat.name}}</a>
                  <template v-if="cat.subCategories && show_el == cat.mid">
                    <ul>
                      <li v-for="subcat in cat.subCategories" :key="subcat.mid">
                        <a @click.prevent="showSubmenu(subcat)" :class="{ 'is-active' : active_el == subcat.mid }">{{subcat.name}}</a>
                      </li>
                    </ul>
                  </template>
              </li>
          </ul>
        </div>
    </aside>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'columnFilter',
  computed: {
    ...mapState('catalog', ['filterCats'])
  },
  data () {
    return {
      active_el: null,
      show_el: null,
      colFixed: false,
      scrollPosition: 0,
      colPosY: 0
    }
  },
  mounted () {
    window.addEventListener('scroll', this.updateScroll)
    this.colPosY = document.getElementById('col_filter').offsetTop
  },
  destroyed () {
    window.removeEventListener('scroll', this.updateScroll)
  },
  watch: {
    scrollPosition: function(val) {
      setTimeout(() => {
        this.colFixed = (window.scrollY > this.colPosY)
      }, 30)
    }
  },
  methods: {
    showSubmenu (cat) {
      const id = cat.mid

      if (this.show_el === id) {
        this.show_el = null
      } else if (cat.subCategories) {
        this.show_el = id
      }
      this.navigateTo(id)
    },
    navigateTo (id) {
      const scrollToEl = document.getElementById('catalog_' + id);
      const bodyRect = document.body.getBoundingClientRect().top;
      const headerOffset = 80;
      let elementPosition;
      let offsetPosition;
      let elementRect;

      if (scrollToEl) {
        elementRect = scrollToEl.getBoundingClientRect().top;
        elementPosition = elementRect - bodyRect;
        offsetPosition = elementPosition - headerOffset;

        this.active_el = id
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    },

    updateScroll() {
      this.scrollPosition = window.scrollY
    }
  }
}
</script>
